var map = {
	"./app-store_badge--black.svg": 1523,
	"./background-app-page.jpg": 1524,
	"./icon-app-icon.svg": 1525,
	"./icon-intersport-bookmark.svg": 1526,
	"./logo-intersport.svg": 1527,
	"./play-store_badge--black.svg": 1528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1522;